'use client';

import { Button, ArrowRightLong } from '@baseline/ui';
import styles from './demoButton.module.scss';
import Link from 'next/link';

export default function DemoButton({
  text = 'Book a Demo',
  buttonProps,
  hasEndIcon = false
}: Readonly<{
  text?: string;
  buttonProps?: React.ComponentProps<typeof Button>;
  hasEndIcon?: boolean;
}>) {
  const computedProps: React.ComponentProps<typeof Button> = {
    ...buttonProps
  };

  if (hasEndIcon) {
    computedProps.endIcon = <ArrowRightLong className={styles.endIconBubble} />;
  }

  const demoButtonStyle = hasEndIcon
    ? styles.demoButtonWithEndIcon
    : styles.demoButton;

  return (
    <Link href="/contact-us">
      <Button
        className={demoButtonStyle}
        {...computedProps}
        colorScheme="primary"
      >
        {text}
      </Button>
    </Link>
  );
}
